// extracted by css-extract-rspack-plugin
export default {"formWidth":"_6f37790e"};